import { useEffect, useState } from "react";
import clsx from 'clsx'
import Swal from 'sweetalert2';
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import PermissoesModal from "./PermissoesModal";
import { IPermissoes, IPerfil } from "../../interfaces/IPermissoes";
import PermissoesService from "../../services/PermissoesService";
import PermissoesTabela from "./PermissoesTabela";

const Permissoes = () => {
    const intl = useIntl();
    const { classes } = useLayout();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalTitle, setModalTitle] = useState<string>('');
    const [carregado, setCarregado] = useState<boolean>(false);
    const [abaSelecionada, setAbaSelecionada] = useState<number>(1);
    const [permissaoSelecionada, setPermissaoSelecionada] = useState<IPermissoes>();
    const [permissoes, setPermissoes] = useState<IPermissoes[]>([]);
    const [permissoesFiltradas, setPermissoesFiltradas] = useState<IPermissoes[]>([]);
    const toggleModal = (): void => setShowModal(!showModal);
    const perfis: IPerfil[] = [
      { id: 1, nome: 'Master' } ,
      { id: 2, nome: 'Administrador' },
      { id: 3, nome: 'Analista' },
    ];
    const columns = [
      {
        name: 'Descrição',
        selector:  (row: IPermissoes) => row['descricao'],
        sortable: true,
      },
      {
        name: 'Chave',
        selector: (row: IPermissoes) => row['chave'],
        sortable: true
      },
      {
        name: 'Permissões',
        cell: (row: IPermissoes) => <AcoesPermissoes visualizar={row['visualizar']} criareditar={row['criarEditar']} excluir={row['excluir']} importararquivo={row['importarArquivo']} />
      },
      {
        name: 'Ações',
        cell: (row: IPermissoes) => <AcoesUsuarios excluirusuario={excluirUsuario} editarusuario={editarUsuario} item={row} />,
      }
    ];

    useEffect(() => { 
      preCarregar();
     }, [])

    useEffect(() => {
      setPermissoesFiltradas(permissoes.sort((a, b) =>  ((a.descricao ?? "") > (b.descricao ?? "") ? 1 : -1)).filter(x => x.perfilID === abaSelecionada));
    }, [permissoes, abaSelecionada]);

    async function preCarregar() {
      setCarregado(false);
      await PermissoesService.obterTodos(x => setPermissoes(x));
      setCarregado(true);
    }

    function BotoesHeaderTabela() {
      return <>
        {
          perfis.map((x, index) => <button key={index} type="submit"  id={x.id.toString()} className={`btn btn-filtro ${x.id === abaSelecionada && 'ativo'}`} onClick={() => setAbaSelecionada(x.id)}>{x.nome}</button>)
        }
      </>
    }

    function AcoesPermissoes({ visualizar, criareditar: criarEditar, excluir, importararquivo: importarArquivo }: {visualizar: boolean | undefined, criareditar: boolean | undefined, excluir: boolean | undefined, importararquivo: boolean | undefined}) {
      const corVisualizar = visualizar ? '#00B757' : '#A3A3A3';
      const corCriarEditar = criarEditar ? '#00B757' : '#A3A3A3';
      const corImportarArquivos = importarArquivo ? '#00B757' : '#A3A3A3';
      const corExcluir = excluir ? '#00B757' : '#A3A3A3';

      return <div data-tag="allowRowEvents">
        <i className="far fa-eye fs-1" style={{ color: corVisualizar, marginLeft: '20px' }}/>
        <i className="fas fa-pen fs-1" style={{ color: corCriarEditar, marginLeft: '20px' }}/>
        <i className="fas fa-arrow-up" style={{ color: corImportarArquivos, marginLeft: '20px', fontSize: '22px' }}/>
        <i className="fas fa-trash-alt fs-1" style={{ color: corExcluir, marginLeft: '20px', fontWeight: 'normal' }}/>
      </div>
    }
    
    function AcoesUsuarios({ item, excluirusuario: excluirUsuario, editarusuario: editarUsuario }: { item: IPermissoes, excluirusuario: (permissao: IPermissoes) => void, editarusuario: (Permissao: IPermissoes) => void }) {
      return <div data-tag="allowRowEvents">
        <i onClick={() => editarUsuario(item)} className="fas fa-pen fs-1" style={{ color: '#5E6397', cursor: 'pointer' }}></i>
        <i onClick={() => excluirUsuario(item)} className="bi bi-x-circle fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }}></i>
      </div>
    }

    async function excluirUsuario(permissao: IPermissoes) {
      const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
              confirmButton: 'btn btn-modal-excluir ms-5',
              cancelButton: 'btn btn-modal-cancelar'
          },
          buttonsStyling: false
      });
      const result = await swalWithBootstrapButtons.fire({
          title: 'Remover Permissão',
          text: `Você realmente deseja excluir essa Permissão?`,
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: `Remover`,
          reverseButtons: true
      });

      if (result.isConfirmed) {
        await PermissoesService.excluir(permissao.id, () => setPermissoes(permissoes.filter(e => e.id !== permissao.id)), 'Permissão excluída com sucesso');
      }
    }

    function editarUsuario(permissao: IPermissoes) {
      setPermissaoSelecionada(permissao);
      setModalTitle('Editar Permissão');
      toggleModal();
    }

    async function salvar(permissao: IPermissoes) {
      setPermissaoSelecionada(undefined);

      function funcaoSucesso(data: IPermissoes) {
        setPermissoes([...permissoes.filter(e => e.id !== permissao.id), data]);
        toggleModal();
        preCarregar();
      }
      
      if (!permissao.id) {
        await PermissoesService.criar(permissao, funcaoSucesso, 'Permissão adicionada com sucesso');
      } else {
        await PermissoesService.atualizar(permissao, funcaoSucesso, 'Permissão editada com sucesso');
      }
    }

    return <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.PERMISSIONS' })}</PageTitle>
      <div className='toolbar' id='kt_toolbar'>
          <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex')}>
          <DefaultTitle />
          <PermissoesModal salvar={salvar} perfis={perfis} permissao={permissaoSelecionada} title={modalTitle} show={showModal} toggleModal={toggleModal} />
            <div className='d-flex align-items-center py-1' style={{ width: '100%'  }}>
              <button onClick={() => {
                setPermissaoSelecionada(undefined);
                setModalTitle('Cadastrar Permissão');
                setShowModal(true);
              }} className='btn btn-sm btn-primario' style={{ marginLeft: 'auto' }}>
                <i className="icon-lg text-white fas fa-plus" ></i>
                <span style={{ verticalAlign: 'middle' }}> PERMISSÃO </span>
              </button>
            </div>
        </div>
      </div>
      
      <BotoesHeaderTabela />
      { carregado ? <PermissoesTabela colunas={columns} itens={permissoesFiltradas} /> : <p>Carregando...</p> }
    </>
};

export default Permissoes;